/*global page */
var FakeCation = window.FakeCation || {};

(function (FC) {
  "use strict";

  
  FC.pages = FC.pages || {};
  
  FC.pages.createSelfie = function(ctx) {
    if (FC.utils.webRTCSupported) {
      page('/create/wrtc');
    } else {
      page('/create/input');
    }
    console.log('createSelfie');
  };
}(FakeCation));
